<template>
    <div class="main-content-container container-fluid px-4">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">RETOUR DE Régie</span>
          <h3 class="page-title">{{ "Pour " + user.firstName + " " + user.lastName }}</h3>
        </div>
      </div>
  
      <!-- Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4 mt-3" v-if="loading || !user.connected">
            <div class="card-body">
              <spinner-dot />
            </div>
          </div>
          <template v-else>
            <step-one v-if="step === 1" :user.sync="user" @input="handleStepOne" />
            <step-two v-else-if="step === 2" :user.sync="user" @input="handleStepTwo" />
            <step-three v-else-if="step === 3" :user.sync="user" :request="request" @input="handleStepThree"></step-three>
          </template>
        </div>
      </div>
    </div>
  </template>
    
  <script>
  import SpinnerDot from "../../components/layout/Loading/spinner-dot";
  import StepOne from "../../components/retourRegie/request/StepOne.vue";
  import StepTwo from "../../components/retourRegie/request/StepTwo";
  import StepThree from "../../components/retourRegie/request/StepThree";
  import TimeUtils from "../../utils/TimeUtils";
  export default {
    name: "retour-regie-request",
    components: {
      StepThree,
      StepTwo,
      StepOne,
      SpinnerDot
    },
    mounted() {
      this.$services.user.getUsers()
        .then((data) => {
          data.data.forEach((user) => {
            if (user.permissions[0] && user.permissions[0].groupReference == '_super_admin') {
              this.adminRef.push(user.reference);
            }
          })
        }
        ).catch((e) => console.log("error: ", e))
    },
    data() {
      return {
        request: {},
        step: 1,
        loading: false,
        requests: [],
        adminRef: [],
      };
    },
    computed: {
      user() {
        return this.$store.state.user.informations;
      }
    },
  
    methods: {
      handleStepOne(event) {
        this.step = 2;
      },
  
      handleStepTwo(answer) {
        if (!answer) {
          this.step = 1;
        } else {
            this.request.description = answer.description,
            this.request.selectedStructure = answer.selectedStructure,
            this.request.structureID = answer.structureID,
            this.request.structureName = answer.structureName,
            this.request.amount = answer.amount,
            this.request.actualAmount = answer.actualAmount,
            this.request.applicantFirstName = answer.applicantFirstName,
            this.request.applicantLastName = answer.applicantLastName,
            this.request.creationDate = answer.creationDate,
            this.request.applicantID = answer.applicantID,
            this.request.excelDoc = answer.excelDoc,
            this.request.documentsPaths = answer.documentsPaths,
            this.request.selectedRegie = answer.selectedRegie,

          this.step = 3;
        }
      },
  
      getDate(value, date) {
        if (value) {
          if (value == 2) {
            return TimeUtils.getMiddleOfDay(date).valueOf();
          }
  
          return TimeUtils.getFirstHalfOfDay(date).valueOf();
        }
  
        return TimeUtils.getEndOfDay(date).valueOf();
      },
  
      handleStepThree(answer) {
        if (!answer) {
          this.step = 2;
        } else {
          this.loading = true;
          this.request.documentsPaths.forEach((doc) => {
            doc.progress = null;
          })
          const form = {
            description : this.request.description,
            structureID : this.request.structureID,
            structureName : this.request.structureName,
            amount : this.request.amount,
            actualAmount : this.request.actualAmount,
            applicantFirstName : this.request.applicantFirstName,
            applicantLastName : this.request.applicantLastName,
            applicantID: this.request.applicantID,
            excelDoc: this.request.excelDoc,
            documentsPaths: this.request.documentsPaths,
            selectedRegie: this.request.selectedRegie ? this.request.selectedRegie.reference : '',
            creationDate: new Date(),
          };

          this.$services.retourRegieRequestService.create(form).then(() => {
            localStorage.removeItem('model');
            this.$miniToastr.success(this.$t("days.off.request.success"));
            this.$router.push("/demandes/historique");
          }).catch((e) => {
          console.log("error: ", e)
          this.$miniToastr.error("Une erreur s'est produite."); 
        });
        }
      },
    }
  };
  </script>
    
  <style lang="scss" scoped>
  .main-content>.main-content-container.container-fluid {
    min-height: calc(100vh - #{3.75rem + 3.75rem});
  
    @media screen and (min-width: 320px) and (max-width: 767px) {
      height: 910px;
    }
  }
  </style>
    